export default function PHP_static() {
  return (
    <div>
      <h1>PHP_static</h1>
    </div>
  );
}
